import { useDataSubmit } from 'Simple/Data'

export function useOnClick(props) {
  let submit = useDataSubmit({
    context: 'automation',
    viewPath: props.viewPath,
  })

  return function onClick() {
    submit({ type: 'addAction' })
  }
}
